import { getToken } from "../utils/auth/token";
import config from "../assets/config";

async function callAPI(route, method, body) {
  const accessToken = await getToken();
  const request = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method,
  };
  if (body) {
    request.body = body;
  }
  const response = await fetch(config.base_url + route, request);
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error(response.text());
  }
}

export const callFileAPI = async (route, method, fileType, data) => {
  const accessToken = await getToken();

  let formData;
  if (fileType == 'formData') {
    formData = data
  } else {
    formData = new FormData();
    formData.append(fileType, data);
  }
  const response = await fetch(config.base_url + route, {
    method,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error(await response.text());
  }
};
export async function sendPostRequest(route, data) {
  // console.log(JSON.stringify(data));
  return await callAPI(route, "POST", JSON.stringify(data));
}
export async function sendFileFormDataRequest(route, data, filetype = "video") {
  return await callFileAPI(route, "POST", filetype, data);
}
export async function sendDeleteRequest(route, data) {
  return await callAPI(route, "POST", JSON.stringify(data));
}
export async function sendGetRequest(route) {
  return await callAPI(route, "GET");
}
export async function sendUpdateRequest(route, data) {
  return await callAPI(route, "POST", JSON.stringify(data));
}
export async function sendListRequest(
  route,
  pageSize,
  page,
  sortBy,
  sortOrder,
  filter
) {
  const listRequest = {
    pagination: {
      page: page,
      page_size: pageSize,
    },
    order: [
      {
        data: {},
        desc: sortOrder === "DESC",
        name: sortBy,
      },
    ],
    filter: filter,
  };
  return await callAPI(route, "POST", JSON.stringify(listRequest));
}

export async function sendListRequestWithData(
  route,
  data,
  pageSize,
  page,
  sortBy,
  sortOrder
) {
  const listRequest = {
    data,
    pagination: {
      page: page,
      page_size: pageSize,
    },
    order: [
      {
        data: {},
        desc: sortOrder === "DESC",
        name: sortBy,
      },
    ],
  };

  return await callAPI(route, "POST", JSON.stringify(listRequest));
}
